import { render, staticRenderFns } from "./Startpage.vue?vue&type=template&id=09cf84a5&scoped=true"
import script from "./Startpage.vue?vue&type=script&lang=js"
export * from "./Startpage.vue?vue&type=script&lang=js"
import style0 from "./Startpage.vue?vue&type=style&index=0&id=09cf84a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cf84a5",
  null
  
)

export default component.exports